import { createContext } from 'react'
import type { TableReferenceTarget } from '../reference'

/** Only docked table workspaces intercept reference links; other views keep standalone links. */
export const TableReferenceContext = createContext<((reference: TableReferenceTarget) => boolean) | null>(null)

/** The reference whose source is currently visible in this table's sidebar. */
export const ActiveTableReferenceContext = createContext<string | null>(null)
